import React, { useState, useEffect, createContext, useContext } from "react";
import { PortfolioLnb, PortfolioContents, Pagenation } from "components/items";
import { PortfolioPreview } from "components/section";

// firebase
import firebase from "library/firebase-config.js";
import "firebase/firestore";
import { authContext } from "../../shared/App";
const db = firebase.firestore();
const COLLECTION = "portfolio";
const DOC = "category";

export const portfolioContext = createContext();
const PAGERANGE = 2;
const PortfolioWithLnb = (props) => {
	const [nowLnb, setNowLnb] = useState("all");
	const [lnb, setLnb] = useState([]);
	const [data, setData] = useState([]);
	const { setIsPfLoading } = useContext(authContext);
	const [resultList, setResultList] = useState([]);
	const [nowIndex, setNowIndex] = useState(null);

	// for pagenation---
	const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage] = useState(20);

	const [minPage, setMinPage] = useState(1);
	const [maxPage, setMaxPage] = useState(1 + PAGERANGE * 2);
	const [pageCount, setPageCount] = useState();

	useEffect(() => {
		setCurrentPage(1);
	}, [nowLnb]);

	useEffect(() => {
		setPageCount(Math.ceil(resultList.length / postsPerPage));
	}, [resultList, postsPerPage]);

	useEffect(() => {
		if (currentPage < PAGERANGE + 1) {
			// 1,2,3
			setMinPage(1);
			setMaxPage(PAGERANGE * 2 + 1);
		} else if (currentPage > pageCount - PAGERANGE - 1) {
			// max-2, max-1, max
			setMinPage(pageCount - PAGERANGE * 2);
			setMaxPage(pageCount);
		} else {
			setMinPage(currentPage - PAGERANGE);
			setMaxPage(currentPage + PAGERANGE);
		}
	}, [currentPage, resultList, pageCount]);

	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = resultList.slice(indexOfFirstPost, indexOfLastPost);
	const paginate = (pageNumber) => {
		window.scrollTo(0, 0);
		setCurrentPage(pageNumber);
	};
	const handlePageArrowClick = (right) => {
		if (right) {
			if (currentPage < Math.ceil(resultList.length / postsPerPage)) {
				paginate(currentPage + 1);
			}
		} else {
			if (currentPage > 1) {
				paginate(currentPage - 1);
			}
		}
	};

	// ----

	useEffect(() => {
		const init = async () => {
			setIsPfLoading(true);
			setData(await _get(COLLECTION));
			setLnb(await _get(COLLECTION, DOC));
			setIsPfLoading(false);
		};

		init();
	}, [setIsPfLoading]);

	const _get = async (col, doc) => {
		if (doc) {
			const cate = await db.collection(col).doc(doc).get();
			return cate.data().data;
		} else {
			const cate = await db.collection(col).get();
			const data = cate.docs.filter((el) => {
				return el.id !== DOC;
			});
			const output = data.map((el) => {
				return {
					...el.data(),
					id: el.id,
				};
			});

			return output;
		}
	};

	const handleLnbClicked = (str) => {
		setNowLnb(str);
	};

	const handleListClick = (index) => {
		setNowIndex(index);
	};

	const handleNextImageClick = () => {
		setNowIndex(nowIndex + 1);
	};
	const handlePrevImageClick = () => {
		setNowIndex(nowIndex - 1);
	};

	const handleCloseClick = () => {
		setNowIndex(null);
	};

	return (
		<section className={`PortfolioWithLnb ${props.className}`}>
			<portfolioContext.Provider value={{ nowLnb, handleLnbClicked, nowIndex, lnb, data, setResultList, currentPosts, handleListClick }}>
				<PortfolioLnb />
				<PortfolioContents />
			</portfolioContext.Provider>

			{currentPosts[0] ? (
				<Pagenation
					minPage={minPage}
					maxPage={maxPage}
					handlePageArrowClick={handlePageArrowClick}
					currentPage={currentPage}
					postsPerPage={postsPerPage}
					totalPosts={resultList.length}
					paginate={paginate}
				/>
			) : (
				""
			)}

			{currentPosts[0] && nowIndex !== null ? (
				<PortfolioPreview nowIndex={nowIndex} data={currentPosts} handleNextImageClick={handleNextImageClick} handlePrevImageClick={handlePrevImageClick} handleCloseClick={handleCloseClick} />
			) : (
				""
			)}
		</section>
	);
};

export default PortfolioWithLnb;
